import { BookOpen } from "lucide-react";

/**
 * Open book on the amber mark.
 * Sparkles read as AI. A book reads as a tutor — the loop is in the name.
 */
export const LogoMark = ({ className = "h-5 w-5" }) => (
  <BookOpen className={className} strokeWidth={2.25} aria-hidden="true" />
);

const Logo = ({ className = "" }) => (
  <span className={`flex items-center gap-2 ${className}`.trim()}>
    <span className="relative flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-orange-500 to-amber-500 shadow-lg shadow-orange-500/20">
      <LogoMark className="h-5 w-5 text-white" />
    </span>
    <span className="text-lg font-bold tracking-tight bg-gradient-to-r from-orange-500 to-amber-500 bg-clip-text text-transparent">
      CognitLoop
    </span>
  </span>
);

export default Logo;
